import React from 'react';
import { LockIcon, ZapIcon, CheckCircleIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const CHECKOUT_URL = 'https://www.thesolutionkit.com/cart/43869237575783:1';
function handleCheckout() {
  trackAddToCart({
    content_name: 'Solo-Survival: El Protocolo Despensa 1.0',
    value: 9500,
    currency: 'CLP'
  });
  window.location.href = CHECKOUT_URL;
}
export function PricingSection() {
  const included = ['Guía Maestra Solo-Survival (PDF 45 páginas)', 'Calculadora Excel de gastos por compra y gastos mensuales', 'Mapa de Mayoristas de Chile', 'Planificador de Compra Inteligente', 'BONO: Mini-guía "Zero Waste"'];
  return <section id="pricing" className="w-full bg-[#F5F2EB] py-20 px-4" data-id="element-212" data-mp="226i60j3j3thj">
      <div className="max-w-2xl mx-auto" data-id="element-213" data-mp="2v8kbkbvye9v">
        {/* Section Title */}
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1B3022] mb-4 text-center" data-id="element-214" data-mp="7ts9dtls066g">
          Recupera el control de tu economía personal
        </h2>
        <p className="text-lg text-[#5a5a4f] mb-10 text-center" data-id="element-215" data-mp="1mi9c99fdp8mf">
          Todo lo que necesitas para dejar de regalar tu sueldo al supermercado.
        </p>

        {/* Included Items */}
        <ul className="space-y-3 mb-10 max-w-md mx-auto" data-id="element-216" data-mp="1crmx1gbkqk49">
          {included.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-217" data-mp="17td5dfp261ne" data-mpi={index}>
              <CheckIcon className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-218" data-mp="25fslad1u6r8u" />
              <span className="text-[#3a3a32] text-base" data-id="element-219" data-mp="20gpg8sluwl0v">{item}</span>
            </li>)}
        </ul>

        {/* Trust Bar */}
        <div className="bg-[#1B3022] rounded-2xl px-6 py-4 mb-8" data-id="element-220" data-mp="1vg1ou5tpu264">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8" data-id="element-221" data-mp="1rgarfj9oonsm">
            <div className="flex items-center gap-2" data-id="element-222" data-mp="k1xugyj7uc0j">
              <LockIcon className="w-4 h-4 text-[#e8943a]" data-id="element-223" data-mp="k3iu32ke0l59" />
              <span className="text-sm font-medium text-white/90" data-id="element-224" data-mp="g0cm9qhmmlwo">
                Compra 100% segura
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-225" data-mp="hijhfod97v3x">
              <ZapIcon className="w-4 h-4 text-[#e8943a]" data-id="element-226" data-mp="mh4h9molgcru" />
              <span className="text-sm font-medium text-white/90" data-id="element-227" data-mp="mei7rhi57n6z">
                Acceso inmediato al PDF
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-228" data-mp="chnb745fjwvc">
              <CheckCircleIcon className="w-4 h-4 text-[#22c55e]" data-id="element-229" data-mp="ckhx7043dpqv" />
              <span className="text-sm font-medium text-white/90" data-id="element-230" data-mp="3uv3cgm3qru4a">
                Garantía de 7 días
              </span>
            </div>
          </div>
        </div>

        {/* Urgency Banner */}
        <div className="bg-[#fef3c7] border border-[#f59e0b]/30 rounded-xl px-5 py-3 mb-6 text-center" data-id="element-231" data-mp="3l01mjo1n6o0n">
          <p className="text-sm md:text-base font-semibold text-[#1a2332]" data-id="element-232" data-mp="3pxur6cnar9yt">
            ⚠️ OFERTA DE LANZAMIENTO: Solo quedan{' '}
            <span className="font-bold text-[#ef4444]" data-id="element-233" data-mp="3fzdtyxxrlz4b">[14]</span> cupos con el
            precio reducido de $9.500 CLP antes de subir a $19.990
          </p>
        </div>

        {/* CTA Button */}
        <button id="pricing-cta" onClick={handleCheckout} className="w-full py-5 px-8 bg-[#C5A059] text-white text-lg md:text-xl font-bold rounded-full hover:bg-[#b8923e] transform hover:scale-[1.02] transition-all duration-200 shadow-lg mb-8 tracking-wide" data-id="element-234" data-mp="2sc0a7jnj0pcl">
          ¡DESCARGAR MI PROTOCOLO AHORA!
        </button>

        {/* Price Block */}
        <div className="text-center mb-10" data-id="element-235" data-mp="3g7mff3wc194z">
          <p className="text-base text-[#5a5a4f]" data-id="element-236" data-mp="3bbnu5p6aw78s">
            Acceso instantáneo •{' '}
            <span className="line-through text-[#999]" data-id="element-237" data-mp="3p2ixyn1xzy5i">$19.990</span>{' '}
            <span className="font-bold text-[#1B3022] text-4xl" data-id="element-238" data-mp="3l0nx1jnxbms9">
              $9.500 CLP
            </span>{' '}
            <span className="inline-block bg-[#22c55e] text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-239" data-mp="2ujddkhqg65d">
              -52%
            </span>{' '}
            • Pago único de por vida
          </p>
        </div>

        {/* Guarantee Box */}
        <div className="bg-[#1B3022] rounded-2xl px-6 py-6 md:px-8" data-id="element-240" data-mp="hxkqq5j2xstx">
          <div className="flex items-start gap-4" data-id="element-241" data-mp="lymik1ao32lv">
            <div className="flex-shrink-0 mt-0.5" data-id="element-242" data-mp="lxbes1h81uur">
              <ShieldCheckIcon className="w-8 h-8 text-[#22c55e]" data-id="element-243" data-mp="qrfo2rdymez0" />
            </div>
            <div data-id="element-244" data-mp="vpqwcxolwhf4">
              <h4 className="text-white font-bold text-lg mb-2" data-id="element-245" data-mp="vo62zbe134iu">
                Garantía de Recuperación de Inversión
              </h4>
              <p className="text-white/80 leading-relaxed text-sm md:text-base" data-id="element-246" data-mp="3v6yyzuoev21q">
                Si en tu primera compra de supermercado aplicando el protocolo
                no ahorras al menos el triple de lo que costó esta guía, te
                devolvemos el 100% de tu dinero. Sin preguntas.
              </p>
            </div>
          </div>
          {/* Payment Icons */}
          <div className="flex items-center justify-center gap-6 mt-5 pt-5 border-t border-white/10" data-id="element-247" data-mp="1jetq33wim0pz">
            <span className="text-xs font-bold tracking-wider text-white/40 border border-white/20 rounded px-3 py-1.5" data-id="element-248" data-mp="1ocbqu70dp9mw">
              WebPay
            </span>
            <span className="text-xs font-bold tracking-wider text-white/40 border border-white/20 rounded px-3 py-1.5" data-id="element-249" data-mp="33y5iqwjdo57a">
              VISA
            </span>
            <span className="text-xs font-bold tracking-wider text-white/40 border border-white/20 rounded px-3 py-1.5" data-id="element-250" data-mp="2u7avppyb51ks">
              Mastercard
            </span>
          </div>
        </div>
      </div>
    </section>;
}